import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { asyncRequest, Entities, Projection, TOMCAT_URL } from 'src/common';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';
import TableHelper from 'src/utils/table-helper';
import _ from 'lodash';
import calendarSeasonCalculationModal from 'src/components/administration/calendar-season-calculation/components/calendar-season-calculation-modal';
import CalendarSeasonCalculationCalendarModal from 'src/components/administration/calendar-season-calculation/components/calendar-season-calculation-calendar-modal';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import { ButtonColors } from 'src/utils/constants';
import { IconLabel } from 'src/components/administration/IconLabel';

class CalendarSeasonCalculationAdministration extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.tableHelper = new TableHelper();

        this.state = {
            startedFetching: false,
        };
    }

    componentWillMount() {
        this.props.fetchByCompanyId(Entities.CALENDAR_SEASON_CALCULATION, this.props.selectedCompany, Projection.FULL);
        this.props.fetchByCompanyId(Entities.CALCULATION, this.props.selectedCompany, Projection.FULL);
        this.props.fetchByCompanyId(Entities.CALENDAR_SEASON, this.props.selectedCompany, Projection.FULL);
    }

    componentDidUpdate(prevProps) {
        if (
            this.tableHelper.processPaginationAfterUpdate(
                prevProps.calendarSeason,
                this.props.calendarSeasonCalculation,
                this.table,
            )
        )
            this.setState({ renderSelection: !this.state.renderSelection });
    }

    componentWillReceiveProps(nextProps) {
        const { calendarSeasonCalculation } = nextProps;

        if (calendarSeasonCalculation.isFetching && !this.state.startedFetching)
            this.setState({ startedFetching: true });
        this.tableHelper.processPagination(calendarSeasonCalculation.items.length);

        if (!_.isEqual(calendarSeasonCalculation, this.props.calendarSeasonCalculation)) {
            this.setState({ calendarSeason: nextProps.calendarSeason });
        }
    }

    tableActionsFormatter(cell, calendarSeasonCalculation) {
        const { t } = this.props;
        return (
            <div>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() =>
                        this.props.openModal({
                            component: calendarSeasonCalculationModal,
                            componentProps: {
                                calendarSeasonCalculation: calendarSeasonCalculation,
                                calendarSeasons: this.props.calendarSeason,
                                calculations: this.props.calculations,
                                isCreate: false,
                            },
                            title: calendarSeasonCalculation.name,
                            mandatoryFields: true,
                        })
                    }>
                    <span className="glyphicon glyphicon-pencil text-info" />
                </button>
                <button
                    type="button"
                    className="btn btn-xs transparent"
                    onClick={() =>
                        asyncRequest(
                            `${TOMCAT_URL}api/${Entities.CALENDAR_SEASON_CALCULATION.repository}/${calendarSeasonCalculation.id}/deletable`,
                        )
                            .then(() => this.openConfirmDeleteDialog(calendarSeasonCalculation))
                            .catch(() => this.openCannotDeleteDialog())
                    }>
                    <span title={t('user_functionality.delete')} className="glyphicon glyphicon-trash text-danger" />
                </button>
            </div>
        );
    }

    openConfirmDeleteDialog(calendarSeasonCalculation) {
        const { t } = this.props;
        if (this.table) this.table.reset();
        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: calendarSeasonCalculation,
                onProceedDialog: this.onProceedDelete,
                bodyText: t('calendar_season_calculation.confirm_deletion'),
                proceedText: t('user_functionality.delete'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.DANGER,
            },
            title: calendarSeasonCalculation.name,
            noButtons: true,
        });
    }

    onProceedDelete(calendarSeasonCalculation) {
        this.props.deleteById(
            calendarSeasonCalculation.id,
            Entities.CALENDAR_SEASON_CALCULATION,
            this.props.selectedCompany,
        );
    }
    openCannotDeleteDialog() {
        const { t } = this.props;
        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                bodyText: t('calendar_season_calculation.error.not_deletable'),
                proceedText: t('common_phrases.ok'),
                proceedButtonColor: ButtonColors.NOTIFY,
                isNotification: true,
            },
            title: t('common_phrases.attention'),
            noButtons: true,
        });
    }

    render() {
        const { t, calendarSeasonCalculation, calculations, calendarSeason } = this.props;

        const finishFetching = this.state.startedFetching && !calendarSeasonCalculation.isFetching;
        const tableData = [];

        if (finishFetching && calendarSeasonCalculation.items.length > 0) {
            calendarSeasonCalculation.items.map(calc => {
                tableData.push({
                    id: calc.id,
                    name: calc.name,
                    isDefault: calc.default,
                    seasonAndCalculations: calc.seasonAndCalculations,
                    entity: calc,
                });
            });
        }

        return (
            <>
                <legend className="legend">
                    {t('calendar_season_calculation.title')}
                    <button
                        className="btn btn-xs btn-blue pull-right"
                        onClick={() => {
                            if (this.table) this.table.reset();
                            this.props.openModal({
                                component: calendarSeasonCalculationModal,
                                componentProps: {
                                    isCreate: true,
                                    calculations: calculations,
                                    calendarSeasons: calendarSeason,
                                },
                                title: t('calendar_season_calculation.title'),
                                mandatoryFields: true,
                            });
                        }}>
                        <IconLabel icon="plus" text={t('calendar_season_calculation.add')} />
                    </button>
                </legend>
                <BootstrapTableErrorBoundary>
                    <BootstrapTable
                        ref={ref => (this.table = ref)}
                        data={tableData}
                        exportCSV={true}
                        striped={true}
                        hover={true}
                        condensed={true}
                        pagination={true}
                        options={Object.assign({}, this.tableHelper.getOptions(finishFetching))}
                        selectRow={Object.assign({}, this.tableHelper.getRowProps())}
                        searchPlaceholder={t('common_phrases.search')}
                        search={true}>
                        <TableHeaderColumn columnTitle={true} dataField="id" hidden={true} isKey={true} export={true} />
                        <TableHeaderColumn columnTitle={true} dataField="name" dataSort={true}>
                            {t('common_phrases.name')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            columnTitle={true}
                            width="200"
                            dataFormat={cell => this.seasonCalculationTableFormatter(cell, 'calendarSeason')}
                            dataField="seasonAndCalculations"
                            dataSort={false}
                            tdStyle={{ padding: '0px' }}>
                            {t('calendar_season_calculation.form.season')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            columnTitle={true}
                            width="100"
                            dataFormat={cell => this.seasonOverviewTableFormatter(cell)}
                            dataField="seasonAndCalculations"
                            dataSort={false}
                            tdStyle={{ padding: '0px' }}>
                            {t('calendar_season_calculation.season_duration')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            columnTitle={true}
                            dataFormat={cell => this.seasonCalculationTableFormatter(cell, 'calculation')}
                            dataField="seasonAndCalculations"
                            dataSort={false}
                            tdStyle={{ padding: '0px' }}>
                            {t('calendar_season_calculation.calculation')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="actions"
                            width="90"
                            dataFormat={this.tableActionsFormatter}
                            export={false}>
                            {t('common_phrases.actions')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            </>
        );
    }

    seasonCalculationTableFormatter(seasonAndCalculation, type) {
        return (
            <>
                {seasonAndCalculation.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            padding: '5px',
                            width: '120%',
                            backgroundColor: index % 2 !== 0 ? '#cdcdcd' : 'transparent',
                        }}>
                        {item[type].name}
                    </div>
                ))}
            </>
        );
    }

    seasonOverviewTableFormatter(seasonAndCalculations) {
        return (
            <>
                {seasonAndCalculations.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            padding: '5px',
                            width: '120%',
                            backgroundColor: index % 2 !== 0 ? '#cdcdcd' : 'transparent',
                        }}>
                        <span
                            className="glyphicon glyphicon-calendar text-info"
                            style={{ cursor: 'pointer' }}
                            title={this.props.t('calendar_season_calculation.show_season_in_calendar')}
                            onClick={() =>
                                this.props.openModal({
                                    component: CalendarSeasonCalculationCalendarModal,
                                    componentProps: {
                                        calendarSeason: item.calendarSeason,
                                        i18n: this.props.i18n,
                                    },
                                    title: item.name,
                                    noButtons: true,
                                })
                            }
                        />
                    </div>
                ))}
            </>
        );
    }
}

export default withTranslation()(composeModalActions(CalendarSeasonCalculationAdministration));
